// This is the "common" entry-point for webpack
// It should include all common, shared and vendor resources to be webpack-ed, that are not specific to this app.

// Include required Font Awesome 5 resources for iconography

// SVG Version:
// Depends: @fortawesome/fontawesome
// Optional: @fortawesome/fontawesome-free-brands @fortawesome/fontawesome-free-regular @fortawesome/fontawesome-free-solid
// require('./font-awesome-svg')

// Web Font Version - works better for Pseudo Elements:
// Free ones:
// require('./sass/font-awesome-webfonts.scss')
// Pro Fonts.
require("@fortawesome/fontawesome-pro/css/light.css");
require("@fortawesome/fontawesome-pro/css/solid.css");
require("@fortawesome/fontawesome-pro/css/regular.css");
require("@fortawesome/fontawesome-pro/css/brands.css");
require("@fortawesome/fontawesome-pro/css/duotone.css");
require("@fortawesome/fontawesome-pro/css/fontawesome.css");

// Load styles
require('./sass/application.scss');

module.exports = {
   // Hook to allow triggering actions on page load
   onDocumentReady: (callback) => { window.onload = callback }
}
